// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".box-border[data-v-1e932772]{border:1px solid #e5e5e5;border-radius:5px}.active-box-border[data-v-1e932772]:hover{cursor:pointer}.disabled[data-v-1e932772]:hover{cursor:not-allowed}.box-inside-border[data-v-1e932772]{border-style:solid;border:1px dashed var(--primary)}.box-height[data-v-1e932772]{min-height:140px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
